import React from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';

const PrivacyPolicyPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper 
        elevation={0} 
        sx={{ 
          p: 4, 
          borderRadius: 4,
          boxShadow: '0 8px 30px rgba(0,0,0,0.08)'
        }}
      >
        <Typography 
          variant="h3" 
          component="h1" 
          gutterBottom 
          sx={{ 
            color: '#1a1a1a', 
            fontWeight: 700,
            fontFamily: '"Playfair Display", serif'
          }}
        >
          Política de Privacidad
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" paragraph>
          Última actualización: {new Date().toLocaleDateString('es-MX')}
        </Typography>

        <Box sx={{ my: 4 }}>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, color: '#444' }}>
            En <strong>Blüm</strong>, valoramos su privacidad y nos comprometemos a proteger sus datos personales. Esta Política de Privacidad explica cómo recopilamos, usamos y compartimos su información cuando utiliza nuestra aplicación móvil y sitio web.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box component="section" sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, fontFamily: '"Playfair Display", serif' }}>
            1. Información que Recopilamos
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, color: '#444' }}>
            Podemos recopilar la siguiente información cuando utiliza nuestros servicios:
          </Typography>
          <ul>
            <li style={{ marginBottom: '16px' }}>
              <Typography variant="body1" sx={{ color: '#444' }}>
                <strong>Información Personal:</strong> Nombre, dirección de correo electrónico, número de teléfono, dirección de envío y facturación.
              </Typography>
            </li>
            <li style={{ marginBottom: '16px' }}>
              <Typography variant="body1" sx={{ color: '#444' }}>
                <strong>Información de Pago:</strong> Detalles necesarios para procesar sus pedidos (procesados de forma segura por proveedores externos como Stripe).
              </Typography>
            </li>
            <li style={{ marginBottom: '16px' }}>
              <Typography variant="body1" sx={{ color: '#444' }}>
                <strong>Información del Dispositivo:</strong> Modelo del dispositivo, sistema operativo, identificadores únicos y datos de uso de la aplicación.
              </Typography>
            </li>
          </ul>
        </Box>

        <Box component="section" sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, fontFamily: '"Playfair Display", serif' }}>
            2. Uso de la Información
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, color: '#444' }}>
            Utilizamos su información para los siguientes propósitos:
          </Typography>
          <ul>
            <li style={{ marginBottom: '8px' }}><Typography variant="body1" sx={{ color: '#444' }}>Procesar y entregar sus pedidos de arreglos florales.</Typography></li>
            <li style={{ marginBottom: '8px' }}><Typography variant="body1" sx={{ color: '#444' }}>Comunicarnos con usted sobre el estado de su pedido o consultas de servicio al cliente.</Typography></li>
            <li style={{ marginBottom: '8px' }}><Typography variant="body1" sx={{ color: '#444' }}>Mejorar nuestra aplicación y experiencia de usuario.</Typography></li>
            <li style={{ marginBottom: '8px' }}><Typography variant="body1" sx={{ color: '#444' }}>Enviar notificaciones promocionales (si ha dado su consentimiento).</Typography></li>
            <li style={{ marginBottom: '8px' }}><Typography variant="body1" sx={{ color: '#444' }}>Cumplir con obligaciones legales y prevenir fraudes.</Typography></li>
          </ul>
        </Box>

        <Box component="section" sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, fontFamily: '"Playfair Display", serif' }}>
            3. Compartir Información
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, color: '#444' }}>
            No vendemos su información personal. Solo compartimos datos con terceros en las siguientes circunstancias:
          </Typography>
          <ul>
            <li style={{ marginBottom: '16px' }}><Typography variant="body1" sx={{ color: '#444' }}><strong>Proveedores de Servicios:</strong> Empresas que nos ayudan con el procesamiento de pagos, envío de pedidos y alojamiento de servidores.</Typography></li>
            <li style={{ marginBottom: '16px' }}><Typography variant="body1" sx={{ color: '#444' }}><strong>Cumplimiento Legal:</strong> Cuando sea requerido por ley o para proteger nuestros derechos legales.</Typography></li>
          </ul>
        </Box>

        <Box component="section" sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, fontFamily: '"Playfair Display", serif' }}>
            4. Seguridad de Datos
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, color: '#444' }}>
            Implementamos medidas de seguridad técnicas y organizativas para proteger su información personal contra acceso no autorizado, pérdida o alteración.
          </Typography>
        </Box>

        <Box component="section" sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, fontFamily: '"Playfair Display", serif' }}>
            5. Sus Derechos
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, color: '#444' }}>
            Usted tiene derecho a acceder, corregir o eliminar su información personal. Puede gestionar su perfil directamente en la aplicación o contactarnos para ejercer estos derechos.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, color: '#444' }}>
            Si desea eliminar su cuenta permanentemente, puede solicitarlo a través de nuestra sección de soporte o enviando un correo a nuestro contacto oficial.
          </Typography>
        </Box>

        <Box component="section" sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, fontFamily: '"Playfair Display", serif' }}>
            6. Contacto
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, color: '#444' }}>
            Si tiene preguntas sobre esta Política de Privacidad, puede contactarnos en:
          </Typography>
          <Box sx={{ p: 3, bgcolor: '#f8f9fa', borderRadius: 2 }}>
            <Typography variant="body1" sx={{ mb: 1, color: '#444' }}>
              <strong>Email:</strong> soporte@blum-art.mx
            </Typography>
            <Typography variant="body1" sx={{ color: '#444' }}>
              <strong>Teléfono:</strong> +52 2222222222
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicyPage;
